import { FunctionComponent } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

type ConfirmationDialogProps = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    deleteLoading?: boolean;
    body: string;
    confirmButtonText: string;
};

export const ConfirmationDialog: FunctionComponent<ConfirmationDialogProps> = ({
    open,
    onClose,
    onConfirm,
    deleteLoading = false,
    body,
    confirmButtonText,
}) => {
    return (
        <Dialog open={open}>
            <DialogTitle>Bestätigung</DialogTitle>

            <DialogContent>{body}</DialogContent>

            <DialogActions>
                <Button onClick={onClose} variant='outlined'>
                    Abbrechen
                </Button>
                <LoadingButton
                    loading={deleteLoading}
                    onClick={onConfirm}
                    color='error'
                    variant='contained'
                >
                    {confirmButtonText}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};
